@if (cardModalService.auditWindowOpen()) {
    <wk-card-audit-trail
        #windowDialog
        [dialogMinWidth]="1030"
        [dialogWidth]="1030"
        [dialogMinHeight]="718"
        [cardId]="cardModalService.currentCard()?.cardId"
        (close)="closeAudit()"
    />
}

@if (isTaxCardsPanelVisible) {
    <wk-tax-card-panel />
} @else if (isJobsBillingCardsPanelVisible) {
    <wk-jobs-billing-card-panel />
}
